import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMissingAccountExternalIdRedirect } from "@hooks";
import { useNavigate } from 'react-router-dom';
import AcceptLineOfCreditWrapper from "./AcceptLineOfCredit.styles";
import { Paragraph } from "@components/paragraph";
import { PageWrapper } from "@containers/PageWrapper/pageWrapper";
import { Paper } from "@components/paper";
import SectionHeading from "../../components/sectionHeading";
import { Loader } from "../../components/loader/loader";
import actions from "@redux/acceptLineOfCredit/actions"
import { PUBLIC_ROUTE } from "../../route.constants";
import environmentSettings from "@src/constants/environmentSettings";

export const AcceptLineOfCredit = () => {
    const navigate = useNavigate();
    const { queryString } = useSelector(state => state.StartUp);
    const { hasAccepted, acceptFailed } = useSelector(state => state.acceptLineOfCredit);
    const { accountExternalId } = queryString || {};
    const dispatch = useDispatch();

    const { phone } = environmentSettings;

    useMissingAccountExternalIdRedirect({
        queryStringKey: "accountExternalId",
        onMountWithId: (id) => {
            dispatch(actions.submitAcceptLineOfCredit({accountExternalId: id}));
        }
    });
    
    if(hasAccepted) {
        setTimeout(function() {
            const resumption = PUBLIC_ROUTE.LANDING + '?id=' + accountExternalId;
            navigate(resumption);
            window.location.reload();
        }, 6000)
    }

    const FailedLineOfCredit = () => (
        <PageWrapper>
            <Paper>
                <AcceptLineOfCreditWrapper maxWidth="720px">
                    <SectionHeading heading="An issue has occurred"/>
                    <Paragraph size="p0" textAlign="center">
                        Apologies, there is an issue accepting your Line Of Credit. Please check your link is valid and try again.
                    </Paragraph>
                    <Paragraph size="p0" textAlign="center">
                        If you need any assistance, please call us on <a href={`tel:${phone}`}>{phone}</a>.
                    </Paragraph>
                </AcceptLineOfCreditWrapper>
            </Paper>
        </PageWrapper>
    )

    const SuccessLineOfCredit = () => (
        <PageWrapper>
            <Paper>
                <AcceptLineOfCreditWrapper maxWidth="720px">
                    <SectionHeading 
                        heading="Thank you!"
                        subheading="You're one step closer to securing a flexible line of credit!"
                    />
                    <Paragraph textAlign="center">
                        Simply complete the few final details we need for your assessment - we're taking you there right now 
                    </Paragraph>
                </AcceptLineOfCreditWrapper>
            </Paper>
        </PageWrapper>
    );

    const RenderLineOfCredit = () => {
        if(acceptFailed) {
            return <FailedLineOfCredit />
        }
        if(hasAccepted) {
            return <SuccessLineOfCredit />
        }
        return  <Loader />
    } 

    return (
        <RenderLineOfCredit />
    );
}
